'use client';

import useGetUser from 'hooks/useGetUser';
import useIsSignedIn from 'hooks/useIsSignedIn';
import usePotentiallyAccredited from 'hooks/usePotentiallyAccredited';
import PrivateOfferingPopup from './PrivateOfferingPopup';

const AccreditedExplorePopup = ({ utmContent, storageKey, scrollPercent = 30, delayMs }) => {
  const signedIn = useIsSignedIn();
  const { data: user } = useGetUser();
  const { isPotentiallyAccredited } = usePotentiallyAccredited({
    primaryUserId: user?.primaryUserId,
    enabled: signedIn === true && !!user?.primaryUserId,
  });

  if (!isPotentiallyAccredited) return null;

  return (
    <PrivateOfferingPopup
      variant="explore-cta"
      utmContent={utmContent}
      storageKey={storageKey}
      scrollPercent={scrollPercent}
      delayMs={delayMs}
    />
  );
};

export default AccreditedExplorePopup;
